<div class="modal-header">Edit Map Entity</div>
<div class="p-2">
  <div>Name</div>
  <input
    type="text"
    class="form-control"
    placeholder="Map entity name"
    [(ngModel)]="mapEntity.name"
  />
  <div class="row" class="mt-2 row">
    <div class="col-lg-3"></div>
    <div class="col-lg-3">
      <button
        type="button"
        class="btn btn-danger w-100"
        (click)="onOk()"
      >
        OK
      </button>
    </div>
    <div class="col-lg-3">
      <button
        type="button"
        class="btn btn-default w-100"
        (click)="onCancel()"
      >
        Cancel
      </button>
    </div>
    <div class="col-lg-3"></div>
  </div>
</div>